import React from "react";
const AudioTag = (props)=>{
    window.mp3Player = new Audio()
    return (
        <audio className="audio-element" ref={ref =>  window.mp3Player = ref}/>
    )
}

export default AudioTag;